import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentBuyers, IMAGES } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    cycleTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-257" data-mp="116cylrz1hnad">
      {visible && !dismissed && <motion.div role="status" aria-live="polite" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[92px] left-3 right-3 z-50 flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(10,22,40,0.22)] ring-1 ring-navy-900/10 sm:right-auto sm:max-w-sm md:bottom-6 md:left-6" data-id="element-258" data-mp="1fwbz41e2hat0">
          <img src={IMAGES.product} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-canvas object-contain" data-id="element-259" data-mp="s4n1q6me1w57" />
          <div className="min-w-0" data-id="element-260" data-mp="28mkitxo9439p">
            <p className="text-sm leading-snug text-ink" data-id="element-261" data-mp="23lwgifuko006">
              <strong data-id="element-262" data-mp="23nhbg6kstkyk">{buyer.name}</strong> from <strong data-id="element-263" data-mp="2aotia7mktlfi">{buyer.country}</strong> just purchased{' '}
              <span className="font-semibold text-radar-deep" data-id="element-264" data-mp="2aqnv0ynp278i">Implant Risk Radar™</span>
            </p>
            <p className="mt-0.5 flex items-center gap-1 text-xs text-muted" data-id="element-265" data-mp="2fpr02j3ocdgh">
              <BadgeCheckIcon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-266" data-mp="2knad5fomyk6u" />
              Verified purchase · {minutes} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted hover:bg-canvas hover:text-ink" aria-label="Close notification" data-id="element-267" data-mp="1ryv1920swhzq">
            <XIcon className="h-4 w-4" data-id="element-268" data-mp="21u6hxpvrrza4" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}